var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8431 0.5H3.2378C2.5978 0.5 2.07736 1.02044 2.07736 1.66044C2.07736 2.30044 2.5978 2.82088 3.2378 2.82088H14.0369L0.340219 16.5211C-0.113407 16.9747 -0.113407 17.7097 0.340219 18.1633C0.793845 18.6169 1.52879 18.6169 1.98242 18.1633L15.6791 4.46307V15.2622C15.6791 15.9022 16.1995 16.4226 16.8395 16.4226C17.4795 16.4226 18 15.9022 18 15.2622V1.66044C18.0035 1.02044 17.4831 0.5 16.8431 0.5Z",
    fill: "#013B70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRightArrow);
export default __webpack_public_path__ + "static/media/up-right-arrow.587677ec8ff19a36c05139f90609afcd.svg";
export { ForwardRef as ReactComponent };